var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.kind,_vm._b({tag:"component",attrs:{"mode":_vm.mode,"activeItem":_vm.activeItem},on:{"add":function($event){return _vm.$emit('add')},"click-item":function($event){return _vm.$emit('click-item', $event)},"delete-item":function($event){return _vm.$emit('delete-item', $event)}}},'component',_vm.block,false))
}
var staticRenderFns = []

export { render, staticRenderFns }